import { FC } from 'react'
import { Box, Typography } from '@mui/material'
import { ErrorOutline } from '@mui/icons-material'

const ErrorOverlay: FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        padding: 3,
        textAlign: 'center'
      }}
    >
      <ErrorOutline sx={{ fontSize: 48, color: 'error.main', mb: 2 }} />
      <Typography variant="h6" color="error" gutterBottom>
        Failed to load data
      </Typography>
      <Typography variant="body2" color="textPrimary" sx={{ color: '#fff' }}>
        An error occurred while fetching the data. Please try refreshing the page.
      </Typography>
    </Box>
  )
}

export default ErrorOverlay
